import React, { useState, useEffect, forwardRef } from "react"; // Importar forwardRef
import InputTextClausulas from "./InputTextClausulas";
import "../css/InputTextAreaContainer.css";

// Envolvemos el componente con forwardRef
const InputTextAreaContainer = forwardRef(
  ({ inputText, show, onChange }, ref) => {
    const [textValue, setTextValue] = useState(inputText || "");

    useEffect(() => {
      setTextValue(inputText || "");
    }, [inputText]);

    if (!show) return null;

    return (
      <div className="text-container">
        <InputTextClausulas
          ref={ref} // <--- Pasamos la ref recibida al hijo
          tabIndex={0}
          id="texto"
          type="type-full"
          size={0}
          input={textValue}
          onChange={(value) => {
            setTextValue(value);
            if (onChange) onChange(value);
          }}
        />
      </div>
    );
  }
);

export default InputTextAreaContainer;
